import React, { useState } from 'react'
import '../assets/css/tooltips.css'

const Tooltip = (props) => {
  const [active, setActive] = useState(false)
  const showTip = (e) => {
    if (e.target.value === null || e.target.value === '' || e.target.value === undefined) {
      setActive(true)
    } else {
      setActive(false)
    }
  }
  return (
    <div
      className='Tooltip-Wrapper'
      // When to show the tooltip
      onBlur={showTip}
    >
      {/* Wrapping */}
      {props.children}
      {active && (
        <div className={`Tooltip-Tip ${props.direction || 'top'}`}>
          {/* Content */}
          {props.content}
        </div>
      )}
    </div>
  )
}

export default Tooltip
